import RoleEnum from '@/common/role.enum'

export default [
  {
    path: '/knowledge-type',
    name: 'knowledge-type',
    component: () => import('@/views/Knowledge-Type/index.vue'),
    meta: {
      title: 'Knowledge Type',
      auth: [RoleEnum.SUPER_ADMIN]
    }
  }
]
